module.exports = __webpack_public_path__ + "static/media/zorro.b209be09.png";